import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {result} from 'lodash';
import DatasourceModel from '../../../../../../models/datasource';
import ColumnModel from '../../../../../../models/datasource/column';
import TableModel from '../../../../../../models/datasource/table';
import {queryBuilderState} from '../../../../../../services/query_builder_state';
import SchemaBrowserTable from './table';

export default class SchemaBrowser extends Component {
    tableRefs = {};

    render() {
        const {
            datasource,
            toggleDataTable,
            expandAll,
            selectedTable,
            selectedColumn,
            hoveredColumn,
        } = this.props;
        const tables = datasource.getFirstSchema().tables;
        return tables.length === 0 ? (
            <div className="empty-search-message">
                No columns with the name &quot;{queryBuilderState.searchQuery}&quot; exist in the database.
            </div>
        ) : (
            <>
                <h5>TABLES</h5>
                <ul className="closed w-list-unstyled" ref={(el) => { this.list = el; }}>
                    {tables.map(table => (
                        <SchemaBrowserTable
                            key={table.fullName}
                            table={table}
                            expanded={expandAll || result(selectedTable, 'id') === table.id}
                            toggleDataTable={show => toggleDataTable(table, show)}
                            selectedColumn={selectedColumn}
                            hoveredColumn={hoveredColumn}
                            ref={(el) => { this.tableRefs[table.id] = el; }}
                        />
                    ))}
                </ul>
            </>
        );
    }
}

SchemaBrowser.propTypes = {
    datasource: PropTypes.instanceOf(DatasourceModel).isRequired,
    selectedTable: PropTypes.instanceOf(TableModel),
    selectedColumn: PropTypes.instanceOf(ColumnModel),
    hoveredColumn: PropTypes.instanceOf(ColumnModel),
    toggleDataTable: PropTypes.func.isRequired,
    expandAll: PropTypes.bool,
};

SchemaBrowser.defaultProps = {
    expandAll: false,
    selectedTable: null,
};
